import { render } from "./SzDialogDiallel.vue?vue&type=template&id=fae8ddd6&scoped=true"
import script from "./SzDialogDiallel.vue?vue&type=script&lang=ts"
export * from "./SzDialogDiallel.vue?vue&type=script&lang=ts"

import "./SzDialogDiallel.vue?vue&type=style&index=0&id=fae8ddd6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-fae8ddd6"

export default script